export default __webpack_public_path__ + "static/media/firefox-add-on.71f96b5e.png";